var window_ = typeof window !== 'undefined' ? window : global;
var global_ = typeof global !== 'undefined' ? global : window;
var document_ = typeof document !== 'undefined' ? document : {};
export { window_ as window, global_ as global, document_ as document };
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-map-gl/dist/esm/utils/globals.js
// module id = 414
// module chunks = 0